module.exports = __webpack_public_path__ + "img/00-menu-bar-off_02.bc216f94.png";